var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostpondedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "posponed",
    d: "M10.4271 6.93185V11.8751M10.4271 14.841H10.437M5.48386 1V2.97728M15.3703 1V2.97728M4.69295 18.7956H16.1612C17.2686 18.7956 17.8223 18.7956 18.2453 18.58C18.6173 18.3905 18.9198 18.088 19.1093 17.716C19.3249 17.293 19.3249 16.7393 19.3249 15.6319V6.14094C19.3249 5.03355 19.3249 4.47986 19.1093 4.0569C18.9198 3.68485 18.6173 3.38236 18.2453 3.1928C17.8223 2.97728 17.2686 2.97728 16.1612 2.97728H4.69295C3.58557 2.97728 3.03187 2.97728 2.60891 3.1928C2.23686 3.38236 1.93437 3.68485 1.74481 4.0569C1.5293 4.47986 1.5293 5.03355 1.5293 6.14094V15.6319C1.5293 16.7393 1.5293 17.293 1.74481 17.716C1.93437 18.088 2.23686 18.3905 2.60891 18.58C3.03187 18.7956 3.58556 18.7956 4.69295 18.7956Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostpondedIcon);
export default __webpack_public_path__ + "static/media/Postponded_icon.47e03066165cc42b425f4ac790b35d5e.svg";
export { ForwardRef as ReactComponent };